import React from "react";

export default class PropsProxy extends React.Component {
    render() {
        if (this.props.children instanceof Function) {
            const props = {...this.props};
            delete props.children;
            return this.props.children(props);
        }
        return React.Children.map(this.props.children, (child) => {
            if (child instanceof Function || child === null || child === undefined) {
                return child;
            }
            return <child.type {...{
                ...((child || {}).props || {}),
                ...this.props,
                children: ((child || {}).props || {}).children
            }} />;
        });
    }
}